import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { AuthProvider, AuthGate } from "./auth/AuthContext";
import { TenantProvider } from "./app/TenantContext";
import { router } from "./router";
// Order matters: Tailwind (base + utilities) first, then our design tokens
// and component CSS so they win the cascade against preflight defaults.
import "./index.css";
import "./styles/theme.css";
import "./styles/layout.css";
import "./styles/screens.css";
import "./styles/tweaks.css";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root-Element #root fehlt im index.html");

createRoot(rootEl).render(
  <StrictMode>
    <AuthProvider>
      <AuthGate>
        <TenantProvider>
          <RouterProvider router={router} />
        </TenantProvider>
      </AuthGate>
    </AuthProvider>
  </StrictMode>
);
